// extracted by mini-css-extract-plugin
export default {"iconTabs":"recordHeader__iconTabs___hS2oQ","iconBadge":"recordHeader__iconBadge___d71SZ","messageCount":"recordHeader__messageCount___CUKVM"};